// REDESIGN 2024

// sentry je zatím zakomentované - build procházel, i když nebylo nainstalované @sentry/browser, což rozbíjelo produkci (přestávalo fungovat jQuery)
// !!! import * as Sentry from '@sentry/browser';

const navigationInit = async () => {
    const navigationElement: HTMLElement | null = document.querySelector('[data-navigation]');

    if (navigationElement) {
        const { navigation } = await import(
            /* webpackChunkName: 'chunk-navigation' */
            './components/navigation/navigation.ts'
        );

        navigation(navigationElement);
    }
};

export const swiperInit = async () => {
    const swiperSelectors: NodeListOf<HTMLElement> = document.querySelectorAll('[data-swiper]');

    if (swiperSelectors.length > 0) {
        const { swiper } = await import(
            /* webpackChunkName: 'chunk-swiper' */
            './components/swiper.ts'
        );

        for (const swiperSelector of swiperSelectors) {
            if (swiperSelector instanceof HTMLDivElement) swiper(swiperSelector);
        }
    }
};

// HP stripe počasí – vyhledávání obce + geolokace
const weatherSearchInit = async () => {
  const weatherSearchElements: NodeListOf<HTMLElement> =
    document.querySelectorAll('[data-weather-search]');

  if (weatherSearchElements.length > 0) {
    const { weatherSearch } = await import(
      /* webpackChunkName: 'chunk-weatherSearch' */
      './components/weatherSearch.ts'
    );

    weatherSearch(weatherSearchElements);
  }
};

// Součást navigace
const dynamicNavigationInit = async () => {
    const dynamicNavigationTemplate: HTMLTemplateElement | null = document.querySelector(
        '[data-dynamic-navigation-template]',
    );

    if (dynamicNavigationTemplate) {
        const { dynamicNavigation } = await import(
            /* webpackChunkName: 'chunk-dynamicNavigation' */
            './components/navigation/dynamicNavigation.ts'
        );

        dynamicNavigation(dynamicNavigationTemplate);

        swiperInit();
    }
};

// Součást navigace
const infoStripInit = async () => {
    const infoStripElement: HTMLElement | null = document.querySelector('[data-info-strip]');

    if (infoStripElement) {
        const { infoStrip } = await import(
            /* webpackChunkName: 'chunk-infoStrip' */
            './components/navigation/infoStrip.ts'
        );
        infoStrip({
            infoStripElement,
        });
    }
};

const breakingNewsInit = async () => {
    const breakingNewsTemplate: HTMLTemplateElement | null = document.querySelector(
        '[data-breaking-news-template]',
    );

    if (breakingNewsTemplate) {
        const { breakingNews } = await import(
            /* webpackChunkName: 'chunk-breakingNews' */
            './components/navigation/breakingNews/breakingNews.ts'
        );

        breakingNews(breakingNewsTemplate);
    }
};

const giftsAIInit = async () => {
    const giftsAIFormElement: HTMLFormElement | null =
        document.querySelector('[data-gifts-ai-form]');

    if (giftsAIFormElement) {
        const { giftsAI } = await import(
            /* webpackChunkName: 'chunk-giftsAI' */
            './components/giftsAI/giftsAi.ts'
        );
        giftsAI({ form: giftsAIFormElement });
    }
};

const atomicDesignInit = async () => {
    const articleGalleryBigElement: HTMLElement | null =
        document.querySelector('[data-atomic-design]');

    if (articleGalleryBigElement) {
        const { atomicDesign } = await import(
            /* webpackChunkName: 'chunk-atomicDesign' */
            './modules/atomic-design/atomicDesign.ts'
        );

        atomicDesign();
    }
};

// DS shared — Share toggle (X+FB panel). Hledá [data-share-toggle-wrapper] kdekoliv v DOM.
const shareToggleInit = async () => {
    const wrappers = document.querySelectorAll<HTMLElement>('[data-share-toggle-wrapper]');
    if (wrappers.length === 0) return;

    const { shareToggle } = await import(
        /* webpackChunkName: 'chunk-share-toggle' */
        '@bleskDs/components/share-toggle.ts'
    );

    for (const wrapper of wrappers) {
        shareToggle(wrapper);
    }
};

// DS shared — Ticker (breaking news strip). Hledá [data-ticker] kdekoliv v DOM.
const tickerInit = async () => {
    const elements = document.querySelectorAll<HTMLElement>('[data-ticker]');
    if (elements.length === 0) return;

    const { ticker } = await import(
        /* webpackChunkName: 'chunk-ticker' */
        '@bleskDs/components/ticker.ts'
    );

    for (const el of elements) {
        ticker(el);
    }
};

const contentExpanderInit = async () => {
    const contentExpanderElements: NodeListOf<HTMLElement> =
        document.querySelectorAll('[data-content-expander]');

    if (contentExpanderElements.length > 0) {
        const { contentExpander } = await import(
            /* webpackChunkName: 'chunk-contentExpander' */
            './components/contentExpander.ts'
        );

        contentExpander(contentExpanderElements);
    }
};

const formTextareaInit = async () => {
    const textAreaWrappers: NodeListOf<HTMLDivElement> =
        document.querySelectorAll('[data-form-textarea]');

    if (textAreaWrappers) {
        const { formTextarea } = await import(
            /* webpackChunkName: 'chunk-formTextarea' */
            './element/form/formTextarea.ts'
        );

        formTextarea({ textAreaWrappers });
    }
};

const tooltipInit = async () => {
    const tooltipElements: NodeListOf<HTMLElement> = document.querySelectorAll('[data-tooltip]');

    if (tooltipElements.length > 0) {
        const { tooltip } = await import(
            /* webpackChunkName: 'chunk-tooltip' */
            './element/tooltip.ts'
        );
        tooltip(tooltipElements);
    }
};

const footerLinkListInit = async () => {
    const footerLinkListElements: NodeListOf<HTMLElement> =
        document.querySelectorAll('[data-footer-link-list]');
    if (footerLinkListElements.length > 0) {
        const { footerLinkList } = await import(
            /* webpackChunkName: 'chunk-footerLinkList' */
            './components/footerLinkList.ts'
        );
        footerLinkList(footerLinkListElements);
    }
};

const footerInit = async () => {
    const footerElement: HTMLElement | null = document.querySelector('[data-footer]');
    if (footerElement) {
        const { footer } = await import(
            /* webpackChunkName: 'chunk-footer' */
            './components/footer.ts'
        );
        footer(footerElement);
    }
};

const articleCardListAutoloadInit = async () => {
    const articleCardListAutoloadElements: NodeListOf<HTMLElement> = document.querySelectorAll(
        '[data-article-card-list-autoload]',
    );
    if (articleCardListAutoloadElements.length > 0) {
        const { articleCardListAutoload } = await import(
            /* webpackChunkName: 'chunk-articleCardListAutoload' */
            './components/articleCardListAutoLoad.ts'
        );
        articleCardListAutoload(articleCardListAutoloadElements);
    }
};

const advertisementRightColumInit = async () => {
    const advertisementRightColumElement: HTMLElement | null = document.querySelector(
        '[data-advertisement-right-column]',
    );

    if (advertisementRightColumElement) {
        const { advertisementRightColum } = await import(
            /* webpackChunkName: 'chunk-advertisementRightColumn' */
            './components/advertisementRightColumn.ts'
        );

        advertisementRightColum();
    }
};

/**
 * Modul loadMore inituje a nastavuje komponentu LoadMore, ktera zajistuje asynchronni nacteni obsahu
 *
 * Dynamicky import modulu, pokud existuje element, na ktery se ma aplikovat
 */
const loadMoreInit = async () => {
    /** @type {NodeListOf<HTMLElement>} */
    const loadMoreElements: NodeListOf<HTMLElement> = document.querySelectorAll('[data-load-more]');

    if (loadMoreElements.length) {
        const { loadMore } = await import(
            /* webpackChunkName: 'chunk-load-more' */
            './components/loadMore.ts'
        );

        loadMore(loadMoreElements);
    }
};

const dsaGuardModeratorInit = async () => {
    const moderatorElements: NodeListOf<HTMLElement> = document.querySelectorAll(
        '[data-dsa-guard-moderator]',
    );

    if (moderatorElements.length > 0) {
        const { dsaGuardModerator } = await import(
            /* webpackChunkName: 'chunk-dsaGuardModerator' */
            '@default/scripts/modules/dsa-daktela/dsaGuardModerator'
        );

        dsaGuardModerator(moderatorElements);
    }
};

const articleListedInit = async () => {
    const articleListedElement: HTMLElement | null =
        document.querySelector('[data-article-listed]');
    if (articleListedElement) {
        const { articleListed } = await import(
            /* webpackChunkName: 'chunk-articleListed' */
            './components/article/listed/articleListed.ts'
        );
        articleListed();
    }
};

const articleShareAreaInit = async () => {
    const articleShareAreaElements: NodeListOf<HTMLElement> = document.querySelectorAll(
        '[data-article-share-switcher]',
    );
    if (articleShareAreaElements.length > 0) {
        const { articleShareArea } = await import(
            /* webpackChunkName: 'chunk-articleShareArea' */
            './components/article/articleShareArea.ts'
        );
        articleShareArea();
    }
};

const articleHeaderCaptionInit = async () => {
    const captionElements: NodeListOf<HTMLElement> = document.querySelectorAll(
        '[data-article-header-caption]',
    );

    if (captionElements.length > 0) {
        const { articleHeaderCaption } = await import(
            /* webpackChunkName: 'chunk-articleHeaderCaption' */
            './components/article/articleHeaderCaption.ts'
        );

        articleHeaderCaption(captionElements);
    }
};

/**
 * Načtení všech modulů
 *
 * Všechny funkce pro inicializaci modulů jsou volány paralelně pomocí Promise.all
 */
const speculationAPIInit = async () => {
    const speculationAPIElement: HTMLDivElement | null = document.querySelector(
        '[type="speculationrules"]',
    );

    if (speculationAPIElement) {
        const { speculationAPI } = await import(
            /* webpackChunkName: 'chunk-speculationAPI' */
            './components/speculationAPI.ts'
        );

        speculationAPI();
    }
};

// Pomocné fce pro vývoj a optimalizaci
const devKitInit = async () => {
    if (
        window.location.href.includes('local.cnci.cz') ||
        window.location.href.includes('nocache&CNCdevKit')
    ) {
        const { devKit } = await import(
            /* webpackChunkName: 'chunk-devKit' */
            './components/devKit.ts'
        );

        devKit();
    }
};

const carouselBannersInit = async () => {
    const carouselBannersElements: NodeListOf<HTMLElement> | null =
        document.querySelectorAll('[data-carousel-banners]');
    if (carouselBannersElements) {
        const { carouselBannersGSAP } = await import(
            /* webpackChunkName: 'chunk-carouselBannersGSAP' */
            './components/carouselBannersGSAP.ts'
        );
        carouselBannersGSAP(carouselBannersElements);
    }
};

const modalImageInit = async () => {
    const modalImageElements: NodeListOf<HTMLElement> =
        document.querySelectorAll('[data-modal-image]');

    if (modalImageElements.length > 0) {
        const { modalImage } = await import(
            /* webpackChunkName: 'chunk-modalImage' */
            './components/modalImage.ts'
        );
        modalImage(modalImageElements);
    }
};

const liveTextInit = async () => {
    const liveTextElement: HTMLElement | null = document.querySelector('[data-live-text]');
    if (liveTextElement) {
        const { liveText } = await import(
            /* webpackChunkName: 'chunk-liveText' */
            './components/liveText.ts'
        );
        liveText();
    }
};

const electionsCrossroadInit = async () => {
    const electionsCrossroadElements: NodeListOf<HTMLElement> = document.querySelectorAll(
        '[data-elections-crossroad]'
    );

    if (electionsCrossroadElements.length > 0) {
        const { electionsCrossroad } = await import(
            /* webpackChunkName: 'chunk-electionsCrossroad' */
            './components/electionsCrossroad.ts'
        );
        electionsCrossroad(electionsCrossroadElements);
    }
};

// ACCORDION | Seznam se skrývajícími se tématy
export const accordionInit = async () => {
    const accordionElements: NodeListOf<HTMLDivElement> =
        document.querySelectorAll('[data-accordion]');

    if (accordionElements && accordionElements.length) {
        const { Accordion } = await import(
            /* webpackChunkName: 'chunk-accordion' */
            './components/accordion/index.ts'
        );
        Accordion(accordionElements);
    }
};

/**
 *  Google One click Login Porta
 */
export const dynamicPortaInit = async () => {
    const isPortaInitEnabled =
        new URLSearchParams(window.location.search).get('PortaInit') === 'true';
    if (!isPortaInitEnabled) return;

  // Skip on local development
  const url = window.location.href;

    if (url.includes('.local.cnci.cz')) {
        return;
    } else if (url.startsWith('https://muj.blesk.cz')) {
        const userNotLogged = document.querySelector('[data-user-not-logged]'); // Kontrolujeme, jestli uzivatel uz neni prihlaseny.
        const isDesktopDevice = window.innerWidth > 1080;

        if (userNotLogged && isDesktopDevice) {
            const { PortaInit } = await import(
                /* webpackChunkName: 'portaInit' */
                '@default/scripts/modules/porta/PortaInit'
            );

            PortaInit();
        }
    }
};

// Vyhledávácí
export const searchBarInit = async () => {
    const searchBarElements: NodeListOf<HTMLFormElement> =
        document.querySelectorAll('[data-search-bar]');

    if (searchBarElements && searchBarElements.length) {
        const { searchBar } = await import(
            /* webpackChunkName: 'chunk-searchBar' */
            './components/searchBar.ts'
        );
        searchBar(searchBarElements);
    }
};

// Marfeel recommender pro různé části webu (pokud nabobtná nebylo by špatný samostaný bundle)
export const marfeelRecommenderInit = async () => {
  // Homepage - Nejnovější články Main to Nejlepší
  const articlesNejnovejsiClankyMainToNejlepsi = document.querySelectorAll(
    '.nejnovejsi-clanky-main-to-nejlepsi'
  );

    if (articlesNejnovejsiClankyMainToNejlepsi.length > 0) {
        const { homepageMainToNejlepsi } = await import(
            /* webpackChunkName: 'marfeelRecommenderHomepageMainToNejlepsi' */
            './components/marfeelRecommender/homepageMainToNejlepsi.ts'
        );

        homepageMainToNejlepsi(articlesNejnovejsiClankyMainToNejlepsi);
    }

  // Homepage - Lifestyle - Nejnovější články Lifestyle
  const articlesNejnovejsiClankyLifestyle = document.querySelectorAll(
    '.nejnovejsi-clanky-lifestyle'
  );
  if (articlesNejnovejsiClankyLifestyle.length > 0) {
    const { homepageNejnovejsiClankyLifestyle } = await import(
      /* webpackChunkName: 'marfeelRecommenderHomepageNejnovejsiClankyLifestyle' */
      './components/marfeelRecommender/homepageNejnovejsiClankyLifestyle.ts'
    );
    homepageNejnovejsiClankyLifestyle(articlesNejnovejsiClankyLifestyle);
  }

    // Univerzální feed pro detail článku - Nejnovější články Detail
    const feedsToReplace: NodeListOf<HTMLElement> = document.querySelectorAll(
        '[data-add-mrf-recommended-feed]',
    );
    if (feedsToReplace.length > 0) {
        const { findFeedAndReplace } = await import(
            /* webpackChunkName: 'marfeelRecommenderFindFeedAndReplace' */
            './components/marfeelRecommender/findFeedAndReplace.ts'
        );

        findFeedAndReplace(feedsToReplace);
    }
};

export const matchesUpdates = async () => {
    const matchesWrappers = Array.from(
        document.querySelectorAll('[data-matches-auto-update]'),
    ) as HTMLDivElement[];

    console.log('[WS][matchesUpdates] Wrappers on page:', matchesWrappers.length, matchesWrappers);

    if (matchesWrappers.length === 0) {
        console.log('[WS][matchesUpdates] No [data-matches-auto-update] wrapper — skipping.');
        return;
    }

    const { initAllMatchesUpdates } = await import(
        /* webpackChunkName: 'chunk-sportmod-live-match-websocket-updater' */
        './components/sportmod/live-match-websocket-updater/index.ts'
    );

    for (const wrapper of matchesWrappers) {
        initAllMatchesUpdates(wrapper);
    }
};

const tipsportTrackingInit = async () => {
    if (document.querySelector('[data-tipsport-pixel-src]') === null) {
        return;
    }

    const { tipsportTrackingInit: init } = await import(
        /* webpackChunkName: 'chunk-tipsport-tracking' */
        './components/tipsportTracking/index.ts'
    );

    init();
};

const fortunaOddsInit = async () => {
    if (document.querySelector('[data-fortuna-odds]') === null) {
        return;
    }

    const { fortunaOddsInit: init } = await import(
        /* webpackChunkName: 'chunk-fortuna-odds' */
        './components/fortunaOdds/index.ts'
    );

    init();
};

// MODAL | Zobrazení univerzálního modálního okna
export const modal = async () => {
    const modals: NodeListOf<HTMLElement> = document.querySelectorAll('[data-modal]');

    if (modals && modals.length) {
        const { Modal } = await import(
            /* webpackChunkName: 'default-chunk-modal' */
            './components/modal/index.ts'
        );

        Modal(modals);
    }
};

// Lazy loads animated webp previews on hover (desktop) or viewport center (mobile)
export const animatedPreview = async () => {
    const animatedContainers: NodeListOf<HTMLDivElement> =
        document.querySelectorAll('[data-animated-webp]');

    if (animatedContainers?.length) {
        const { initAnimatedWebpImages } = await import(
            /* webpackChunkName: 'default-animated-preview' */
            './components/images/AnimatedWebpImage.ts'
        );

        initAnimatedWebpImages();
    }
};

Promise.all([
    navigationInit(),
    dynamicNavigationInit(),
    infoStripInit(),
    atomicDesignInit(),
    shareToggleInit(),
    tickerInit(),
    breakingNewsInit(),
    swiperInit(),
    weatherSearchInit(),
    contentExpanderInit(),
    giftsAIInit(),
    formTextareaInit(),
    tooltipInit(),
    footerLinkListInit(),
    footerInit(),
    articleCardListAutoloadInit(),
    advertisementRightColumInit(),
    loadMoreInit(),
    dsaGuardModeratorInit(),
    articleListedInit(),
    articleShareAreaInit(),
    articleHeaderCaptionInit(),
    speculationAPIInit(),
    devKitInit(),
    carouselBannersInit(),
    modalImageInit(),
    liveTextInit(),
    accordionInit(),
    electionsCrossroadInit(),
    dynamicPortaInit(),
    searchBarInit(),
    marfeelRecommenderInit(),
    matchesUpdates(),
    tipsportTrackingInit(),
    fortunaOddsInit(),
    modal(),
    animatedPreview(),
]).then(
    () => {
        // console.log('Všechny moduly načteny.');
    },
    () => {
        // console.log('Some modules not loaded');
    },
);
